import React from "react";
import styled, { keyframes } from "styled-components";


const shimmer = keyframes`
    0% {
        background-position: 100% 0; opacity: 0.3;
    }
    100% {
        background-position: -100% 0; opacity: 0.3;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 640px;
    margin: 0.7rem 0;
`;

const Row = styled.div`
    position: relative;
    overflow: hidden;
    height: 18px;
    border-radius: 8px;
    background: rgba(224, 224, 224, 0.2);

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
                90deg,
                rgba(224, 224, 224, 0) 0%,
                rgba(255, 255, 255, 0.9) 50%,
                rgba(224, 224, 224, 0) 100%
        );
        background-size: 200% 100%;
        animation: ${shimmer} 1.5s ease-in-out infinite;
    }
`;

const RowShort = styled(Row)` width: 70%; `;
const RowMedium = styled(Row)` width: 90%; `;
const RowFull = styled(Row)` width: 100%; `;

const LoadingData = () => (
    <Wrapper role="status" aria-busy="true" aria-live="polite">
        <RowFull />
        <RowMedium />
        <RowShort />
    </Wrapper>
);

export default LoadingData;